var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalPhotos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6157 2.22334L2.40261 6.16354C2.12153 6.27076 1.98099 6.58879 2.08821 6.87059L4.67662 13.5926L3.9855 16.365L0.359706 6.951C0.0344341 6.10849 0.458229 5.15296 1.30075 4.82696L12.536 0.494837C13.3785 0.169566 14.3341 0.593361 14.6593 1.43588L16.3603 5.87087L14.4145 5.3855L13.3235 2.5363C13.2155 2.25594 12.8968 2.1154 12.6157 2.22334Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2742 10.4044C13.2742 11.2254 12.6087 11.891 11.7877 11.891C10.9667 11.891 10.3011 11.2254 10.3011 10.4044C10.3011 9.58343 10.9667 8.91788 11.7877 8.91788C12.6087 8.91788 13.2742 9.58343 13.2742 10.4044Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3712 12.5639C16.2727 12.2611 16.0053 12.1945 15.7771 12.4154L13.6451 14.4743C13.4169 14.6938 13.0953 14.651 12.9316 14.3779L12.5903 13.8121C12.4259 13.539 12.0695 13.4499 11.7971 13.6144L8.33284 15.6804C8.05973 15.8434 8.0945 16.0202 8.40239 16.0977L10.6474 16.6563L10.9937 16.7431C11.2608 16.8101 11.5599 16.885 11.7696 16.9381L14.4217 17.5987C14.6533 17.6558 14.9955 17.7411 15.2823 17.8125L17.7882 18.4376C18.0968 18.5152 18.2641 18.35 18.1656 18.0472L16.3712 12.5639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82227 5.73263L21.506 8.64631C22.3825 8.86581 22.9201 9.76121 22.7013 10.6385L19.7869 22.3215C19.5688 23.1973 18.6727 23.7363 17.7961 23.5182L6.11316 20.6038C5.23659 20.3843 4.69834 19.4904 4.91784 18.6131L7.83152 6.9294C8.04958 6.0521 8.9457 5.51457 9.82227 5.73263ZM18.856 19.2694L20.9757 10.7711C21.0488 10.4799 20.8692 10.1799 20.5765 10.1089L9.95556 7.45896C9.66362 7.38724 9.36442 7.56545 9.29198 7.85812L7.17228 16.355C7.09984 16.6477 7.2795 16.9462 7.57145 17.0186L18.1931 19.6671C18.4843 19.7403 18.7835 19.5606 18.856 19.2694Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalPhotos);
export default __webpack_public_path__ + "static/media/professional-photos.7087cf1ca9356e95bec2b1f7c7f47df4.svg";
export { ForwardRef as ReactComponent };